$(document).ready(function(){
$('a.logo__image-link.logo__image-link--home[href="/"]').attr(
    'aria-label',
    "Jade Yoga logo, trademark, nature's best yoga mat"
);

$('a[href="/cart"]')
    .attr('role', 'button')
    .attr('aria-label', 'Cart'); 

   
   

    $('div.product__media-slide a.product__media').each(function () {
    const img = $(this).find('img');
    const alt = img.attr('alt') || 'Product image';
    $(this).attr('aria-label', alt);
});
let Intervaltime_google;
let counter_google = 0; 
$('img[src="https://cdn.convertcart.com/uploads/cc1163c6.png"]').attr('alt', 'perfect mat quiz');


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
$('a[href="https://cdn.convertcart.com/uploads/250fc5ac.png"]').attr('aria-label', 'Video thumbnail');
$('input.os-e[type="search"]').attr('aria-label', 'Search site');
$('img[src="https://jadeyoga.com/cdn/shop/files/2820_2048x2048.jpg?v=1724787182"]').attr('alt', 'jade cork yoga mat');
   $("div.cc-atc-section-77379794 img").attr("alt","mat");
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');
console.log("code summary started");
   $('.spr-summary').each(function () {
    var $summary = $(this);
    var rating = $.trim($summary.find('.spr-summary-starrating').attr('aria-label'));
    var reviews = $.trim($summary.find('.spr-summary-caption').text());

    if (rating) {
        rating = rating.replace(' of 5 stars', ' out of five-star rating');
    }

    $summary.find('.spr-summary-starrating').attr('aria-label', rating + ' ' + reviews.toLowerCase());

    console.log("code summary executed");
});

$('.cc-sizes').each(function () {
    var text = $(this).text().trim();
    $(this).attr('aria-label', text.replace(/"/g, ' inches'));
});
$('.cc-rating').each(function () {
    $(this).html($(this).attr('datareview'));
});
$("button.cc-filter-btn").attr("aria-label"," has collapsed dropdown list");
$('.collection__filter-tag button, .cc-size-button, .cc-color-button').each(function () {
    var $btn = $(this);

    var label = $.trim(
        $btn.find('.cc-size-name, .cc-color-name').text() || $btn.text()
    ).replace(/"/g, ' inches');

    var checked =
        $btn.hasClass('active') ||
        $btn.hasClass('selected') ||
        $btn.attr('aria-pressed') === 'true';

    $btn.attr({
        'role': 'checkbox',
        'aria-label': label,
        'aria-checked': checked ? 'true' : 'false'
    });
});

$(document).on('click', '.collection__filter-tag button, .cc-size-button, .cc-color-button', function () {
    var $btn = $(this);

    setTimeout(function () {
        var checked =
            $btn.hasClass('active') ||
            $btn.hasClass('selected') ||
            $btn.attr('aria-pressed') === 'true';

        $btn.attr('aria-checked', checked ? 'true' : 'false');
    }, 0);
});

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 
        clearInterval(Intervaltime_google);
       console.log("widget found");
    }
    
  
    if (counter_google >= 50) {
        clearInterval(Intervaltime_google);
       
    }
}
setTimeout(function(){

  $('#cc-search').attr({
    'role': 'combobox',
    'aria-autocomplete': 'list',
    'aria-haspopup': 'listbox',
    'aria-expanded': 'false',
    'aria-label': 'Search site. Suggested searches are available as you type.'
});

$('.cc-filter-div > div[data-filtername]').each(function () {
    var $header = $(this);
    var expanded = $header.closest('.cc-filter-facet').find('.cc-filter-options').is(':visible');

    $header.attr({
        'role': 'button',
        'tabindex': '0',
        'aria-expanded': expanded ? 'true' : 'false',
        'aria-label': $.trim($header.contents().filter(function () {
            return this.nodeType === 3;
        }).text()) + ' dropdown'
    });
});

$(document).on('click', '.cc-filter-div > div[data-filtername]', function () {
    var $header = $(this);

    setTimeout(function () {
        var expanded = $header.closest('.cc-filter-facet').find('.cc-filter-options').is(':visible');
        $header.attr('aria-expanded', expanded ? 'true' : 'false');
    }, 0);
});

$(document).on('keydown', '.cc-filter-div > div[data-filtername]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).click();
    }
});

$('input.os-e[type="search"]').attr('aria-label', 'Search site');
// Set alt for the question mark icon
$('img[src="https://cdn.convertcart.com/uploads/cc1163c6.png"]').attr('alt', 'Question mark icon');

// Set alt for the Jade Yoga product image
$('img[src="https://jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Purple_2048x2048.jpg?v=1631573421"]').attr('alt', 'Jade Yoga Harmony Mat in purple color');

// Set aria-labels for navigation buttons
$('button.cc-arrow-left').attr('aria-label', 'Previous item');
$('button.cc-arrow-right').attr('aria-label', 'Next item');

// Set aria-label for close link
$('a[data-close-type="long_close"]').attr('aria-label', 'Close this window');
$("div#smc-v5-overlay-83901 img").attr("alt"," jade yoga selected mat");


},2000)
// Set aria-labels for search inputs

$('img[src="https://cdn.convertcart.com/uploads/250fc5ac.png"]').attr('alt', 'video icon');



let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;
$('img[src="https://cdn.convertcart.com/uploads/418356ad.svg"]').attr('alt', 'Five out of five-star rating');
$('img[src="https://cdn.convertcart.com/uploads/19842d30.webp"]').attr('alt', 'Five out of five-star rating');
 $('img[src="https://cdn.convertcart.com/uploads/70e90aea.svg"]').attr({
    role: 'button',
    tabindex: '0'
});

$('img[src="https://cdn.convertcart.com/uploads/d4ea6b84.svg"]').attr({
    role: 'button',
    tabindex: '0'
});
$('img[src^="https://jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Purple_2048x2048.jpg"]').attr('alt', 'Jade Yoga Harmony Mat Purple');
$('img[src="https://cdn.convertcart.com/uploads/250fc5ac.png"]').attr('alt', 'Video thumbnail');
$('a[href="https://cdn.convertcart.com/uploads/250fc5ac.png"]').attr('aria-label', 'Product single thumbnail link');
$('iframe[data-testid="shop-cart-sync-iframe"]').attr('title', 'Shop cart synchronization frame');

   
    if ($('a[data-close-type="long_close"].smc-link.smc-closer').length) {


$('a[data-close-type="long_close"].smc-link.smc-closer').attr("aria-label","close link");
        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}
$('img[src="https://cdn.shopify.com/s/files/1/0763/3069/files/Myproject-1_31_2_240x240.jpg?v=1677179880"]').attr('alt', 'This product plants 1 tree');

$('img[src="https://jadeyoga.com/cdn/shop/files/PURPLETWOSIDES_59ff72ea-b54d-499a-bca2-7bb331205154_2048x2048.jpg?v=1717689590"]').attr('alt', 'Purple mat');

$('img[src="//jadeyoga.com/cdn/shop/t/8/assets/blank_1x1.gif?v=50849316544257392421622066539"]').attr('alt', 'Jade Yoga logo, trademark, nature’s best yoga mat. ');

let Intervaltime_task_1;
let counter_task_1 = 0; 


try {
    Intervaltime_task_1 = setInterval(GenerateAriaLabelFortask_1, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask_1() {
   
   counter_task_1++;


   
    if ( $('div#smc-v5-overlay-83901>img').length) {

$('div#smc-v5-overlay-83901>img').attr("alt","jade yoga mat");
        clearInterval(Intervaltime_task_1);
       
    }
    
  
    if (counter_task_1 >= 50) {
        clearInterval(Intervaltime_task_1);
       
    }
}


$("h3:empty").append("<span style='display:none'>.</span>")
$('img[src="https://cdn.shopify.com/s/files/1/0763/3069/files/Cleantheworld2_480x480.png?v=1698419847"]').attr('alt', 'Buy mat wash, Clean the World');
$('a[href="https://online-store-web.shopifyapps.com/admin/online-store/pages/46556165#Albania"]').attr('aria-label', 'Albania');
$('a[href="#austria"]').attr('aria-label', 'Austria');
$('a[href="#bulgaria"]').attr('aria-label', 'Bulgaria');
$('a[href="#colombia"]').attr('aria-label', 'Colombia');
$('a[href="https://jadeyoga.myshopify.com/#hungary"]').attr('aria-label', 'Hungary');
$('a[href="#hungary"]').attr('aria-label', 'Hungary');
$('a[href="#indonesia"]').attr('aria-label', 'Indonesia');
$('a[href="#japan"]').attr('aria-label', 'Japan');
$('a[href="https://jadeyoga.myshopify.com/#malta"]').attr('aria-label', 'Malta');
$('a[href="#malta"]').attr('aria-label', 'Malta');
$('a[href="#russia"]').attr('aria-label', 'Russia');
$('a[href="#singapore"]').attr('aria-label', 'Singapore');
$('a[href="#Albania"]').attr('aria-label', 'Albania');
$('a[href="http://colorpilla.com"]').attr('aria-label', 'Colorpilla website');
$("h3>br:empty").append("<span style='display:none'>.</span>")
$('#RichText--16220676560c384ab8 .rich-text__buttons a[href="/pages/who-we-are"]').attr('aria-label', 'Learn more about Jade yoga');
$('.nav-search[aria-expanded]').attr({
    'role': 'button',
    'tabindex': '0'
});

$("#ProductFeature--16221655373154664d > div > div > div.product-feature__text.product-feature__text--center.rte > a").attr("aria-label","Learn more about matwash")
$('iframe[src^="https://shop.app/pay/hop?analytics_trace_id"]').attr('title', 'Shopping cart sync');
$('div.list-collections__item.carousel__item.one-third[aria-hidden="true"]').removeAttr('aria-hidden');

$("img[src=\"//jadeyoga.com/cdn/shop/files/Jade_Yoga_Logo_White_1024x.webp?v=1723207413\"]").attr("alt", "Jade Harmony Yoga Mat");    
$("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_1024x1024.jpg?v=1696346203\"]").attr("alt", "Sky blue yoga mat, rolled partially unrolled with JadeYoga label");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_2_1024x1024.jpg?v=1696346203\"]").attr("alt", "Teal yoga mat unrolled, JadeYoga logo visible");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_7_1024x1024.jpg?v=1696347951\"]").attr("alt", "Jade Harmony Yoga Mat, sky blue and saffron colors");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Myproject_1024x1024.jpg?v=1696347951\"]").attr("alt", "Black yoga mat folded Olive green yoga mat folded Midnight blue yoga mat folded Purple yoga mat folded Tibetan orange yoga");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2823_1024x1024.jpg?v=1728054807\"]").attr("alt", "Jade Harmony Yoga Mat, rolled at one end, on white background");
$("img[src=\"https://cdn.shopify.com/s/files/1/0763/3069/files/Myproject-1_31_2_240x240.jpg?v=1677179880\"]").attr("alt", "Green badge with tree icon and text This product plants 1 tree");
$("img[src=\"//jadeyoga.com/cdn/shop/files/jade_logo-white-short_2048x2048.png?v=1622152656\"]").attr("alt", "Jade Harmony Yoga Mat");

$("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_1024x1024.jpg?v=1696346203\"]").attr("alt", "Sky blue yoga mat, rolled partially unrolled with JadeYoga label");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_2_1024x1024.jpg?v=1696346203\"]").attr("alt", "Teal yoga mat unrolled, JadeYoga label visible");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_7_1024x1024.jpg?v=1696347951\"]").attr("alt", "Jade Harmony Yoga Mat, sky blue and saffron colors");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Myproject_1024x1024.jpg?v=1696347951\"]").attr("alt", "Black yoga mat folded Olive green yoga mat folded Midnight blue yoga mat folded Purple yoga mat folded Tibetan orange yoga");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2823_1024x1024.jpg?v=1728054807\"]").attr("alt", "Jade Harmony Yoga Mat, rolled at one end, on white background");

$("img[src=\"//jadeyoga.com/cdn/shop/files/jade_logo-white-short_2048x2048.png?v=1622152656\"]").attr("alt", "Jade Harmony Yoga Mat");


$("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Blue_4_1024x1024.jpg?v=1750356139\"]").attr("alt", "Navy blue JadeYoga mat, rolled at one end");
$("img[src=\"//jadeyoga.com/cdn/shop/files/MushroomGroup_10_1024x1024.jpg?v=1750356091\"]").attr("alt", "Jade Yoga mats in purple, red, blue, and green");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Green_4_1024x1024.jpg?v=1750356323\"]").attr("alt", "Green yoga mat with orange trim and JadeYoga logo");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Purple_4_1024x1024.jpg?v=1750356323\"]").attr("alt", "Purple JadeYoga mat, partially rolled up");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Red_4_1024x1024.jpg?v=1750356323\"]").attr("alt", "Jade Yoga mat, unrolled, maroon color");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Purple_3_1024x1024.jpg?v=1750356323\"]").attr("alt", "Rolled purple yoga mat with \"JADEYOGA\" logo");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Purple_8_1024x1024.jpg?v=1750356323\"]").attr("alt", "Purple yoga mat with JadeYoga logo and mushroom design");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Purple_7_1024x1024.jpg?v=1750356323\"]").attr("alt", "JadeYoga logo on purple yoga mat");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Blue_1_1024x1024.jpg?v=1750356323\"]").attr("alt", "Jade Yoga Mushroom Mat packaging");
$("img[src=\"//jadeyoga.com/cdn/shop/files/jade_logo-white-short_2048x2048.png?v=1622152656\"]").attr("alt", "Jade Mushroom Mat"); 


$("img[src=\"//jadeyoga.com/cdn/shop/files/Jade_Yoga_Logo_White_1024x.webp?v=1723207413\"]").attr("alt", "Harmony XW Yoga Mat with eco-friendly and chemical-free text");
$("img[src=\"https://cdn.shopify.com/s/files/1/0763/3069/files/Myproject-1_4_480x480.jpg?v=1664819588\"]").attr("alt", "JadeYoga eco-friendly tree logo with text \"Buy a Mat, Plant a Tree");
$("img[src=\"https://cdn.shopify.com/s/files/1/0763/3069/files/XWHarmony-1_480x480.jpg?v=1665510389\"]").attr("alt", "Man doing yoga outdoors on green mat");
$("img[src=\"//jadeyoga.com/cdn/shop/files/jade_logo-white-short_2048x2048.png?v=1622152656\"]").attr("alt", "Harmony XW Yoga Mat, eco-friendly and chemical-free product");

$("img[src=\"//jadeyoga.com/cdn/shop/files/2815_1024x1024.jpg?v=1725894537\"]").attr("alt", "Jade Extra Yoga Mat, green and black, folded corner with \"JADEYOGA\" logo");
$("img[src=\"//jadeyoga.com/cdn/shop/files/group_0d5eb761-1c1e-456a-bc94-de4ceef55a14_1024x1024.jpg?v=1725894520\"]").attr("alt", "Jade Extra Yoga Mats in red, green, blue, and orange");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2801_1024x1024.jpg?v=1725894508\"]").attr("alt", "Green Jade Yoga mat unrolled");       
$("img[src=\"//jadeyoga.com/cdn/shop/files/2804_1024x1024.jpg?v=1725894508\"]").attr("alt", "Red JadeYoga mat, rolled at one end");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2805_1024x1024.jpg?v=1725894508\"]").attr("alt", "Purple Jade Yoga mat rolled up, \"JADEYOGA\" logo visible");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2806_1024x1024.jpg?v=1725894508\"]").attr("alt", "Orange Jade Extra Yoga Mat rolled up");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2813_1024x1024.jpg?v=1725894536\"]").attr("alt", "Red and black yoga mat with \"JADEYOGA\" logo");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2814_1024x1024.jpg?v=1725894537\"]").attr("alt", "Jade Extra Yoga Mat, orange and black, folded corner");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2816_1024x1024.jpg?v=1725894537\"]").attr("alt", "Purple yoga mat with black underside and JADEYOGA logo");
$("img[src=\"//jadeyoga.com/cdn/shop/files/jade_logo-white-short_2048x2048.png?v=1622152656\"]").attr("alt", "Jade Extra Yoga Mat");

$("img[src=\"//jadeyoga.com/cdn/shop/files/2820_1024x1024.jpg?v=1724787182\"]").attr("alt", "Jade Yoga cork yoga mat with green underside");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2818_1024x1024.jpg?v=1724787182\"]").attr("alt", "Rolled cork yoga mat with JadeYoga branding");
$("img[src=\"//jadeyoga.com/cdn/shop/files/2819_1024x1024.jpg?v=1724787182\"]").attr("alt", "Jade Cork Yoga Mat, rolled partially unrolled, JadeYoga logo visible");

$("img[src=\"//jadeyoga.com/cdn/shop/files/568SB_1024x1024.jpg?v=1691430679\"]").attr("alt", "Blue yoga mat with JadeYoga label"); 
$("img[src=\"//jadeyoga.com/cdn/shop/files/8291A_1024x1024.jpg?v=1715351592\"]").attr("alt", "Green yoga mat with Jade Yoga label");
$("img[src=\"https://cdn.shopify.com/s/files/1/0763/3069/files/Myproject-1_4_480x480.jpg?v=1664819588\"]").attr("alt", "JadeYoga tree logo with text \"Buy a Mat, Plant a Tree");
$("img[src=\"https://cdn.shopify.com/s/files/1/0763/3069/files/blockinfo-1_1_480x480.jpg?v=1664999015\"]").attr("alt", "Woman in yoga pose on black mat outdoors");
$("img[src=\"//jadeyoga.com/cdn/shop/files/jade_logo-white-short_2048x2048.png?v=1622152656\"]").attr("alt", "The Nike logo");     


$("img[src=\"//jadeyoga.com/cdn/shop/files/Mat_Wash_6_1024x1024.jpg?v=1729875436\"]").attr("alt", "JadeYoga plant-based yoga mat cleaner bottles and tablets");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mat_Wash_3_1024x1024.jpg?v=1729875436\"]").attr("alt", "JadeYoga natural yoga mat cleaner and refill tablets");
$("img[src=\"//jadeyoga.com/cdn/shop/files/Mat_Wash_4_1024x1024.jpg?v=1729875436\"]").attr("alt", "JadeYoga mat wash refill tablets packaging and tablets");

 
setTimeout(()=>{

 
    //harmony mat
 $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Purple_2048x2048.jpg?v=1631573421\"]").attr("alt", "Purple yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Cover_2048x2048.jpg?v=1631573421\"]").attr("alt", "Jade yoga harmony mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/harmony_overview_3_2048x2048.jpg?v=1631573421\"]").attr("alt", "Colorful rolls of fabric in purple, orange, red, green, blue, and black");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Black_2048x2048.jpg?v=1631573421\"]").attr("alt", "Black yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Tibetan-Orange_2048x2048.jpg?v=1631573421\"]").attr("alt", "Orange yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Midnight-Blue_2048x2048.jpg?v=1631573421\"]").attr("alt", "Midnight blue yoga mat unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Olive-Green_2048x2048.jpg?v=1631573421\"]").attr("alt", "Olive green yoga mat with Jade Yoga logo");
    
    
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Raspberry_2048x2048.jpg?v=1631573421\"]").attr("alt", "Raspberry colored yoga mat unrolled partially");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Pink_2048x2048.jpg?v=1631573421\"]").attr("alt", "Pink yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Slate-Blue_2048x2048.jpg?v=1631573477\"]").attr("alt", "Blue yoga mat with JadeYoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Jade-Green_2048x2048.jpg?v=1631573477\"]").attr("alt", "Jade green yoga mat rolled partially unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Saffron_2048x2048.jpg?v=1631573477\"]").attr("alt", "Yellow yoga mat unrolled partially");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_2048x2048.jpg?v=1696346203\"]").attr("alt", "Sky blue yoga mat unrolled partially");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_2_2048x2048.jpg?v=1696346203\"]").attr("alt", "Teal yoga mat rolled partially unrolled");

      $("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_2_2048x2048.jpg?v=1696346203\"]").attr("alt", "Teal yoga mat rolled partially unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_7_2048x2048.jpg?v=1696347951\"]").attr("alt", "Jade yoga mat in sky blue and saffron colors");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/4Thick2_preview_38c50f73-5030-4056-a6a5-7f6518b44042_2048x2048.jpg?v=1696347951\"]").attr("alt", "Jade yoga mats in various colors");
 
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2823_2048x2048.jpg?v=1728054807\"]").attr("alt", "Jade Yoga mat in green color");
//harmony 2.0
     $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony_2_28_2048x2048.jpg?v=1764972311\"]").attr("alt", "Navy blue yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony2_49_2048x2048.jpg?v=1764972311\"]").attr("alt", "Rolled yoga mats in purple, blue, black, green, and olive");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony2_50_2048x2048.jpg?v=1764972311\"]").attr("alt", "Jade yoga harmony 2.0 yoga mats in various colors");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony_2_12_2048x2048.jpg?v=1764972311\"]").attr("alt", "Dark green yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony_2_36_2048x2048.jpg?v=1764972311\"]").attr("alt", "Purple yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony2_04_2048x2048.jpg?v=1764972311\"]").attr("alt", "Olive green yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony2_12_2048x2048.jpg?v=1764972311\"]").attr("alt", "Dark green yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony2_20_2048x2048.jpg?v=1764972311\"]").attr("alt", "Black yoga mat with JadeYoga H2O logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony2_28_2048x2048.jpg?v=1764972311\"]").attr("alt", "Navy blue yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony2_36_2048x2048.jpg?v=1764972311\"]").attr("alt", "Purple yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony2_40_2048x2048.jpg?v=1764972311\"]").attr("alt", "Purple yoga mat corner with \"Elyoga H2O\" text");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony_2_20_2048x2048.jpg?v=1764972207\"]").attr("alt", "Black yoga mat with JadeYoga H2O logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Harmony_2_04_2048x2048.jpg?v=1764972256\"]").attr("alt", "Olive green yoga mat with Jade Yoga logo");

    //mushroom mat 

    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Blue_4_2048x2048.jpg?v=1750356139\"]").attr("alt", "Navy blue Jade Yoga mat unrolled on white background");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/MushroomGroup_10_2048x2048.jpg?v=1750356091\"]").attr("alt", "Jade yoga mats in purple, red, blue, and green");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Green_4_2048x2048.jpg?v=1750356323\"]").attr("alt", "Green yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Purple_4_2048x2048.jpg?v=1750356323\"]").attr("alt", "Purple Jade Yoga mat rolled partially unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Red_4_2048x2048.jpg?v=1750356323\"]").attr("alt", "Red Jade Yoga mat partially rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Purple_3_2048x2048.jpg?v=1750356323\"]").attr("alt", "Purple JadeYoga mat rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Purple_8_2048x2048.jpg?v=1750356323\"]").attr("alt", "JadeYoga mat corner with logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Purple_7_2048x2048.jpg?v=1750356323\"]").attr("alt", "JADEYOGA logo with mushroom design");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mushroom_Blue_1_2048x2048.jpg?v=1750356323\"]").attr("alt", "Jade Yoga Mushroom Mat packaging");


    //harmony xw mat 

        $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-XW-Midnight-Blue_2048x2048.jpg?v=1631576030\"]").attr("alt", "Midnight blue yoga mat unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Extra-Wide-Cover_2048x2048.jpg?v=1631576030\"]").attr("alt", "Jade yoga harmony extra wide yoga mat");

    //jade extra yoga mat 

        $("img[src=\"//jadeyoga.com/cdn/shop/files/2815_2048x2048.jpg?v=1725894537\"]").attr("alt", "Green yoga mat with black underside, Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/group_0d5eb761-1c1e-456a-bc94-de4ceef55a14_2048x2048.jpg?v=1725894520\"]").attr("alt", "Four JadeYoga mats in red, green, blue, and orange");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2801_2048x2048.jpg?v=1725894508\"]").attr("alt", "Green Jade Yoga exercise mat unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2804_2048x2048.jpg?v=1725894508\"]").attr("alt", "Red Jade Yoga mat rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2805_2048x2048.jpg?v=1725894508\"]").attr("alt", "Purple Jade Yoga exercise mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2806_2048x2048.jpg?v=1725894508\"]").attr("alt", "Orange Jade Yoga mat rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2813_2048x2048.jpg?v=1725894536\"]").attr("alt", "Red and black yoga mat with JADEYOGA logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2814_2048x2048.jpg?v=1725894537\"]").attr("alt", "Orange and black yoga mat with JADEYOGA logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2816_2048x2048.jpg?v=1725894537\"]").attr("alt", "Purple yoga mat with black underside, Jade Yoga logo");


    //cork yoga mat 
   $("img[src=\"//jadeyoga.com/cdn/shop/files/2820_2048x2048.jpg?v=1724787182\"]").attr("alt", "Cork yoga mat with green underside, Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2818_2048x2048.jpg?v=1724787182\"]").attr("alt", "Rolled up jade yoga mat with cork texture and green underside");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2819_2048x2048.jpg?v=1724787182\"]").attr("alt", "Jade Yoga cork yoga mat unrolled partially");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2825_2048x2048.jpg?v=1724787182\"]").attr("alt", "Jade Yoga cork yoga mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2826_2048x2048.jpg?v=1724787182\"]").attr("alt", "Cork yoga mat with JadeYoga branding");

    //fusion mat

      $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Fusion-Midnight-Blue_2048x2048.jpg?v=1637350470\"]").attr("alt", "Midnight blue yoga mat rolled partially unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/568SBRolled_2048x2048.jpg?v=1637350470\"]").attr("alt", "Jade Yoga Fusion yoga mat, blue, rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/fusion_overview_3_2048x2048.jpg?v=1637350470\"]").attr("alt", "Blue fabric with \"EXTRA THICK\" label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Fusion-Purple_2048x2048.jpg?v=1637350470\"]").attr("alt", "Purple yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/4Thick2_preview_38c50f73-5030-4056-a6a5-7f6518b44042_2048x2048.jpeg?v=1637350470\"]").attr("alt", "Jade yoga mats in various colors");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/568SB_2048x2048.jpg?v=1691430679\"]").attr("alt", "Blue JadeYoga mat partially rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/8291A_2048x2048.jpg?v=1715351592\"]").attr("alt", "Green yoga mat with Jade Yoga label");

//xw fusion mat logo

 $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Fusion-XW-Purple_2048x2048.jpg?v=1631576347\"]").attr("alt", "Purple yoga mat with JadeYoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Fusion-Extra-Wide-Cover_2048x2048.jpg?v=1631576344\"]").attr("alt", "Jade Yoga Fusion yoga mat, purple, rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/EW_and_Extra_Thick_2048x2048.jpg?v=1631576344\"]").attr("alt", "Purple yoga mat with JADEYOGA logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/4Thick2_preview_15bc3cb2-83b9-459e-af26-f964f32ea42d_2048x2048.jpeg?v=1631576347\"]").attr("alt", "Jade yoga mats in various colors");

    //fusion mini

       $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Fusion-Mini-Purple_2048x2048.jpg?v=1631576703\"]").attr("alt", "Purple yoga mat with JadeYoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Fusion-Mini-Mat-Cover_2048x2048.jpg?v=1631576668\"]").attr("alt", "Rolled up Jade Yoga Fusion Mini mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Fusion-Mini-Group_2048x2048.jpg?v=1631576681\"]").attr("alt", "Two JadeYoga mats, one purple and one blue");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Fusion-Mini-Midnight-Blue_2048x2048.jpg?v=1631576703\"]").attr("alt", "Blue yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/IMG_2773-2small_2048x2048.jpg?v=1647877022\"]").attr("alt", "Woman unfolding Jade Yoga mat on wooden floor");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/IMG_2664-2small_2048x2048.jpg?v=1647877033\"]").attr("alt", "Woman in black leggings on a yoga mat in a kneeling position");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/IMG_2750-8small_2048x2048.jpg?v=1647877045\"]").attr("alt", "Person in yoga pose on blue mat");

    //voyager yoga mat 

       $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Voyager-Midnight-Blue_2048x2048.jpg?v=1631573748\"]").attr("alt", "Midnight blue yoga mat rolled partially unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Voyager-Cover_2048x2048.jpg?v=1630649137\"]").attr("alt", "Jade yoga voyager yoga mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Voyager-mat_folded_thumb_78dcaf7b-c9e8-44fe-aa09-368f6acb2866_2048x2048.jpg?v=1631574053\"]").attr("alt", "Folded navy blue yoga mat with JadeYoga label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Voyager-Folded_2048x2048.jpg?v=1631573748\"]").attr("alt", "Jade yoga mat folded");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Voyager-Folded-Olive_2048x2048.jpg?v=1631574033\"]").attr("alt", "Olive green yoga mat with JadeYoga label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Voyager-Folded-Purple_2048x2048.jpg?v=1631574032\"]").attr("alt", "Purple yoga mat with Jade Yoga label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Voyager-Purple_2048x2048.jpg?v=1631573747\"]").attr("alt", "Purple yoga mat with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Voyager-Olive-Green_2048x2048.jpg?v=1631573748\"]").attr("alt", "Olive green yoga mat rolled partially unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Voyager-Folded-Block_2048x2048.jpg?v=1631573748\"]").attr("alt", "Yoga block and purple mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/4Thick2_preview_75597c41-ea58-4f0e-8e83-4b213fa53d61_2048x2048.jpeg?v=1631574053\"]").attr("alt", "Jade yoga mats in various colors");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/668BK_2048x2048.jpg?v=1657737162\"]").attr("alt", "Black yoga mat with JadeYoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Voyager_2_2048x2048.jpg?v=1729875172\"]").attr("alt", "Jade yoga mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Voyager_3_2048x2048.jpg?v=1729875192\"]").attr("alt", "Rolled up dark green yoga mat with Jade Yoga label");

//travel yoga mat

 $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Travel-Midnight-Blue_2048x2048.jpg?v=1631574685\"]").attr("alt", "Midnight blue yoga mat unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Travel-Mat-Cover_2048x2048.jpg?v=1631574623\"]").attr("alt", "Jade Yoga travel yoga mat packaging");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/travel_overview_3_2048x2048.jpg?v=1631574623\"]").attr("alt", "Purple yoga mat with JadeYoga label and \"LIGHTWEIGHT\" text");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Travel-Olive-Green_2048x2048.jpg?v=1631574685\"]").attr("alt", "Olive green yoga mat unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Travel-Purple_2048x2048.jpg?v=1631574685\"]").attr("alt", "Purple yoga mat unrolled and partially rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/4Thick2_preview_5e064d7c-86c7-4c92-a7d1-2083bbdb4490_2048x2048.jpeg?v=1631574685\"]").attr("alt", "Jade yoga mats in various colors");
//elite S 

  $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Elite-S-Forest-Green-Black_2048x2048.jpg?v=1631575475\"]").attr("alt", "Yoga mat, one rolled up and one unrolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Elite-S-Mat-Cover_2048x2048.jpg?v=1631575460\"]").attr("alt", "Jade Yoga Elites yoga mat, rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Elite-S-Forest-Green-Black-Flat_2048x2048.jpg?v=1631575475\"]").attr("alt", "Teal and black foam board with white and green edge trim");

    //level one 

     $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Level-One-Mat-Cover_2048x2048.jpg?v=1631819938\"]").attr("alt", "Jade Yoga Level One Mat Cover");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-LevelOne-Mat-Classic-Purple-Flat_2048x2048.jpg?v=1631819938\"]").attr("alt", "Jade Yoga LevelOne Mat Classic Purple Flat");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-LevelOne-Mat-Classic-Purple-Rolled_2048x2048.jpg?v=1631819938\"]").attr("alt", "Jade Yoga LevelOne Mat Classic Purple Rolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-LevelOne-Mat-Classic-Blue-Rolled_2048x2048.jpg?v=1631819938\"]").attr("alt", "Jade Yoga LevelOne Mat Classic Blue Rolled");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-LevelOne-Mat-Classic-Purple-Folded_2048x2048.jpg?v=1631819938\"]").attr("alt", "Jade Yoga LevelOne Mat Classic Purple Folded");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-LevelOne-Mat-Classic-Blue-Folded_2048x2048.jpg?v=1631819938\"]").attr("alt", "Jade Yoga LevelOne Mat Classic Blue Folded");

//yoga rug 

   $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Organic-Cotton-Mysore-Yoga-Rug-Indigo-Blue_2048x2048.jpg?v=1630642328\"]").attr("alt", "Jade Yoga organic cotton yoga rug in indigo color");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Organic-Cotton-Mysore-Yoga-Rug-Cover_2048x2048.jpg?v=1630642349\"]").attr("alt", "Jade Yoga organic cotton yoga rug, rolled and packaged");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Organic-Cotton-Mysore-Yoga-Rug-Indigo-Blue-Unrolled_2048x2048.jpg?v=1630651870\"]").attr("alt", "Blue yoga mat with Jade Yoga label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Organic-Cotton-Mysore-Yoga-Rug-Anatoo-Orange_2048x2048.jpg?v=1630642327\"]").attr("alt", "Jade Yoga organic cotton yoga rug, coral color, rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Organic-Cotton-Mysore-Yoga-Rug-Karungali-Black_2048x2048.jpg?v=1630642327\"]").attr("alt", "Jade Yoga organic cotton yoga rug rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Organic-Cotton-Mysore-Yoga-Rug-Tulasi-Green_2048x2048.jpg?v=1630642328\"]").attr("alt", "Rolled up jade yoga organic cotton yoga rug");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Organic-Cotton-Mysore-Yoga-Rug-Turmeric-Yellow_2048x2048.jpg?v=1630642328\"]").attr("alt", "Yellow Jade Yoga mat rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Organic-Cotton-Mysore-Yoga-Rug-All-Colors_2048x2048.jpg?v=1630642327\"]").attr("alt", "Jade yoga organic cotton yoga rugs in various colors");

    //saree 

      $("img[src=\"//jadeyoga.com/cdn/shop/products/9159_2048x2048.jpg?v=1599168863\"]").attr("alt", "Colorful striped rug with white border and tassels");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/9160_2048x2048.jpg?v=1599168881\"]").attr("alt", "Multicolored striped woven rugs with white borders and tassels");
//dharba grass mats

    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Dharba-Grass-Yoga-Meditation-Mat-Cover_2048x2048.jpg?v=1631575901\"]").attr("alt", "Rolled grass yoga mat with label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Dharba-Grass-Mat_2048x2048.jpg?v=1631575917\"]").attr("alt", "Jade Yoga bamboo mat with grid pattern");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Dharba-Grass-Mat-Side_2048x2048.jpg?v=1631575917\"]").attr("alt", "Rolled bamboo mat with white backing");

    //cork yoga mat 

      $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mats-Cork-Block-Small_2048x2048.jpg?v=1631577210\"]").attr("alt", "Cork yoga block with JADEYOGA branding");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mats-Cork-Blocks_2048x2048.jpg?v=1631577210\"]").attr("alt", "Jade Yoga cork blocks with tree logo on packaging");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mats-Cork-Block-View_2048x2048.jpg?v=1631577210\"]").attr("alt", "Yoga block on a mat under a person\'s hand");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mats-Cork-Block-Large_2048x2048.jpg?v=1631577210\"]").attr("alt", "Cork yoga block with Jade Yoga logo");

    //yoga strap

     $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Cotton-Yoga-Strap-Black_2048x2048.jpg?v=1631822897\"]").attr("alt", "Black cotton yoga strap with metal ring and label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Cotton-Yoga-Strap-All_2048x2048.jpg?v=1631822897\"]").attr("alt", "Three Jade Yoga 8\' cotton yoga straps in purple, blue, and black");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Cotton-Yoga-Strap-Black-Rolled-2_2048x2048.jpg?v=1631822897\"]").attr("alt", "Black fabric strap with silver rings, rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Cotton-Yoga-Strap-Black-Rolled_2048x2048.jpg?v=1631822897\"]").attr("alt", "Black yoga strap with silver rings");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Cotton-Yoga-Strap-Purple_2048x2048.jpg?v=1631822920\"]").attr("alt", "Purple Jade Yoga 8ft cotton yoga strap");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Cotton-Yoga-Strap-Blue_2048x2048.jpg?v=1631822920\"]").attr("alt", "Jade Yoga 8\' cotton yoga strap, blue, with silver buckle");


    //best yoga and meditation blanket
      $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-Midnight-Blue-Rolled_2048x2048.jpg?v=1631821601\"]").attr("alt", "Jade yoga towel with tassels");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-All-Folded-White_2048x2048.jpg?v=1631821601\"]").attr("alt", "Four rolled blankets with labels");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-All-Flat_2048x2048.jpg?v=1631821601\"]").attr("alt", "Four woven rugs in gray, blue, purple, and beige");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-Midnight-Blue-Folded_2048x2048.jpg?v=1631821601\"]").attr("alt", "Blue and white woven yoga mat with tassels and Jade Yoga label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-Purple-Rolled_2048x2048.jpg?v=1631821601\"]").attr("alt", "Purple yoga mat with cream-colored tassels and Jade Yoga label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-Purple-Folded_2048x2048.jpg?v=1631821601\"]").attr("alt", "Purple yoga mat with cream-colored tassels and label reading \"JADE YOGA\"");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-Teal-Rolled_2048x2048.jpg?v=1631821601\"]").attr("alt", "Turquoise yoga mat with cream-colored tassels and label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-Teal-Folded_2048x2048.jpg?v=1631821601\"]").attr("alt", "Turquoise yoga mat with beige tassels and jade yoga label");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-Black-Rolled_2048x2048.jpg?v=1631821601\"]").attr("alt", "Jade Yoga towel with tassels");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Recycled-Cotton-Blanket-Black-Folded_2048x2048.jpg?v=1631821601\"]").attr("alt", "Tasselled yoga mat with Jade Yoga branding");


    //yoga bloster 

     $("img[src=\"//jadeyoga.com/cdn/shop/products/RECBOLSTERBLACK_2048x2048.jpg?v=1637093191\"]").attr("alt", "Black yoga bolster pillow with JadeYoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/ROUNDBOLSTERGROUP_2048x2048.jpg?v=1637093191\"]").attr("alt", "Three Jade Yoga bolsters in black, yellow, and purple");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/RECBOLSTERGROUP_2048x2048.jpg?v=1637093193\"]").attr("alt", "Three JadeYoga bolsters in purple, tan, and black");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/ROUNDBOLSTERBLACK_2048x2048.jpg?v=1637093192\"]").attr("alt", "Black yoga bolster pillow with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/ROUNDBOLSTERLAV_2048x2048.jpg?v=1637093192\"]").attr("alt", "Lavender yoga bolster pillow with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/ROUNDBOLSTERKHAKI_2048x2048.jpg?v=1637093191\"]").attr("alt", "Beige yoga bolster pillow with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/RECBOLSTERKHAKI_2048x2048.jpg?v=1637093191\"]").attr("alt", "Jade Yoga bolster pillow");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/RECBOLSTERLAV_2048x2048.jpg?v=1637093192\"]").attr("alt", "Lavender JadeYoga bolster pillow");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/3682_890bffb6-c201-4987-a55e-70762f70b566_2048x2048.jpg?v=1690291184\"]").attr("alt", "Blue body pillow with green logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/3677_3b1b7851-8e78-4178-a5f3-ee44475c71e5_2048x2048.jpg?v=1690291259\"]").attr("alt", "Purple bolster pillow with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/3690_ed0d213a-a2a9-4962-9edd-c81f3dfd826e_2048x2048.jpg?v=1690291331\"]").attr("alt", "Blue yoga bolster pillow with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/3687_2240ad84-d5cb-4ff8-a49d-787df2fafa7b_2048x2048.jpg?v=1690291416\"]").attr("alt", "Purple yoga bolster pillow with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/bolstersupinecloseup2_2048x2048.jpg?v=1691594762\"]").attr("alt", "Woman lying on yoga mat with head tilted back");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/flatbolstercloseup3_2048x2048.jpg?v=1691594793\"]").attr("alt", "Woman resting forehead on yoga bolster on a mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/bolsterchilds2_2048x2048.jpg?v=1691594838\"]").attr("alt", "Woman resting on yoga bolster and block on purple mat");

    //meditation cushion

     $("img[src=\"//jadeyoga.com/cdn/shop/products/ROUNDCUSHIONBLACK_2048x2048.jpg?v=1637095086\"]").attr("alt", "Black meditation cushion with teal logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/RECTANGULARCUSHIONGROUP_2048x2048.jpg?v=1637095087\"]").attr("alt", "Three JadeYoga mats in purple, brown, and black");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/RECTANGULARCUSHIONKHAKI_2048x2048.jpg?v=1637095088\"]").attr("alt", "Jade yoga mat folded in beige color");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/RECTANGULARCUSHIONLAVENDER_2048x2048.jpg?v=1637095087\"]").attr("alt", "Lavender yoga mat bag with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/RECTANGULARCUSHIONBLACK_2048x2048.jpg?v=1637095087\"]").attr("alt", "Black folded yoga mat cover with JadeYoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/CUSHIONSSTACKED_2048x2048.jpg?v=1637095790\"]").attr("alt", "Jade Yoga meditation cushion and mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/ROUND_CUSHION_GROUP_2_2048x2048.jpg?v=1754490696\"]").attr("alt", "Three JadeYoga zafu meditation cushions in purple, black, and blue");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/ROUND_CUSHION_MIDNIGHT_BLUE_58b15871-3c75-454b-b749-cfda05078be4_2048x2048.jpg?v=1754490718\"]").attr("alt", "Blue meditation cushion with gathered bottom and embroidered logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/ROUND_CUSHION_DARK_PURPLE_2048x2048.jpg?v=1754490694\"]").attr("alt", "Purple meditation cushion with gathered bottom and green logo");

    //mat cleaner
       $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Wash-4oz_2048x2048.jpg?v=1632168183\"]").attr("alt", "Yoga mat cleaner spray bottle");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mat_Wash_6_2048x2048.jpg?v=1729875436\"]").attr("alt", "JADE Yoga plant-based yoga mat cleaners and refill tablets");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Wash-8oz_2048x2048.jpg?v=1632168183\"]").attr("alt", "Jade Yoga plant-based yoga mat cleaner spray bottle");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Wash-Spray_2048x2048.jpg?v=1632168183\"]").attr("alt", "Hand holding yoga mat cleaning spray bottle");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Mat-Wash-On-Mat_2048x2048.jpg?v=1632168183\"]").attr("alt", "Jade Yoga plant-based yoga mat cleaner spray bottle");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mat_Wash_3_2048x2048.jpg?v=1729875436\"]").attr("alt", "JADE Yoga plant-based mat wash and refill tablets");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Mat_Wash_4_2048x2048.jpg?v=1729875436\"]").attr("alt", "Jade Yoga mat wash refill tablets packaging with tree logo");

// double grip yoga towel

    $("img[src=\"//jadeyoga.com/cdn/shop/files/PURPLETWOSIDES_59ff72ea-b54d-499a-bca2-7bb331205154_2048x2048.jpg?v=1717689590\"]").attr("alt", "Purple rugs with black designs");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/TowelDuo_8a54aafe-2053-416d-99f9-c66fbfff863c_2048x2048.jpg?v=1717689590\"]").attr("alt", "Jade Yoga double grip chamois yoga towels, purple and blue");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/MIDNIGHTTWOSIDES_480e869c-a5ef-494a-8cce-315a9b2cc5cd_2048x2048.jpg?v=1717689591\"]").attr("alt", "Blue rug with geometric pattern and embroidered design");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/MIDNIGHTFRONT_8b2800b8-da29-45bb-9d12-d74beffc1a25_2048x2048.jpg?v=1717689590\"]").attr("alt", "Geometric patterned blue rug with border");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/PURPLEBACK_eb1de7e1-6a6e-4775-a948-b101168a96a7_2048x2048.jpg?v=1717689590\"]").attr("alt", "Purple scarf with geometric pattern");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/MIDNIGHTBACK_71d26eeb-e22c-4e7b-9a00-c93f4c4b4fd5_2048x2048.jpg?v=1717689590\"]").attr("alt", "Blue embroidered scarf with floral pattern and tag");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/PURPLEFRONT_1233b602-1cbd-4d64-9675-f4252243f0e5_2048x2048.jpg?v=1717689591\"]").attr("alt", "Purple scarf with floral pattern and border");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/MIDNIGHTTOWEL_7105a797-b4b3-4f3a-a8f7-5583956891b9_2048x2048.jpg?v=1717689590\"]").attr("alt", "Jade Yoga double grip chamois yoga towel packaging");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/PURPLETOWEL_dcfd0c01-6911-4e85-bef0-3ac4d0ceb5e6_2048x2048.jpg?v=1717689589\"]").attr("alt", "Jade Yoga double grip chamois yoga towel");

    //great grip yoga towel

       $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Microfiber-Mat-Towel-Orchid_2048x2048.jpg?v=1632169537\"]").attr("alt", "Rolled up pink yoga towel with JADEYOGA logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Mat_Towel_MidnightBlue_2048x2048.jpg?v=1632169495\"]").attr("alt", "Navy blue Jade Yoga microfiber towel with tree logo packaging");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/towel_featured_2048x2048.jpg?v=1632169495\"]").attr("alt", "Purple JadeYoga towel with white logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Microfiber-Mat-Towel-Slate-Blue_2048x2048.jpg?v=1632169537\"]").attr("alt", "Rolled blue yoga towel with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Microfiber-Mat-Towel-Midnight-Blue_2048x2048.jpg?v=1632169537\"]").attr("alt", "Rolled navy blue yoga towel with JADE YOGA logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Microfiber-Mat-Towel-Purple_2048x2048.jpg?v=1632169537\"]").attr("alt", "Purple Jade Yoga towel rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/mattowelgroupnew_2048x2048.jpg?v=1678805033\"]").attr("alt", "Four Jade Yoga microfiber towels in different colors");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Lifestyle-15_preview_2048x2048.jpg?v=1678805040\"]").attr("alt", "Person in yoga pose on purple JadeYoga mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/jadealltowels_8b606372-c6e9-47f1-b6fe-96473a12c01f_2048x2048.jpg?v=1678805048\"]").attr("alt", "Stacked JadeYoga towels in purple, blue, navy, and pink");

    //yoga hand towel

      $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Microfiber-Mat-Towel-Midnight-Blue_c07cb33c-38ba-4514-9563-2906dbe1563c_2048x2048.jpg?v=1632169814\"]").attr("alt", "Rolled navy blue yoga towel with JADE YOGA logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/towel_featured2_2048x2048.jpg?v=1632169779\"]").attr("alt", "Jade Yoga logo on blue towel");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Microfiber-Mat-Towel-Orchid_cbb5f45e-8e45-4253-b679-21f2fbf05c20_2048x2048.jpg?v=1632169814\"]").attr("alt", "Rolled up pink yoga towel with JADEYOGA logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Microfiber-Mat-Towel-Purple_321b6a2f-464a-4593-8576-9bad061e715e_2048x2048.jpg?v=1632169814\"]").attr("alt", "Purple Jade Yoga towel rolled up");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Microfiber-Mat-Towel-Slate-Blue_312049e9-3f96-4235-b29c-b348dd8368f1_2048x2048.jpg?v=1632169814\"]").attr("alt", "Rolled blue yoga towel with Jade Yoga logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/handtowelsgroupnew_2048x2048.jpg?v=1678804891\"]").attr("alt", "Four Jade Yoga microfiber hand towels in different colors");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/jadealltowels_2048x2048.jpg?v=1678804897\"]").attr("alt", "Stacked JadeYoga towels in purple, blue, navy, and pink");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Lifestyle-18_2048x2048.jpg?v=1678804935\"]").attr("alt", "Hand holding blue JadeYoga towel outdoors");

    //yoga starter kit for beginners

      $("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_54_2048x2048.jpg?v=1698420188\"]").attr("alt", "Jade Yoga products including blue mat, cork blocks, strap, and spray");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Level_One_Blue_2048x2048.jpg?v=1543864819\"]").attr("alt", "Blue yoga mat with Level One logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Level_One_Purple_3_3d4a8150-79a6-4c73-a085-8e66c4f0db7f_2048x2048.jpg?v=1543864819\"]").attr("alt", "Folded purple yoga mat with Level One logo");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/Cork_Block_2_2048x2048.jpg?v=1543864819\"]").attr("alt", "Cork yoga block with label");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_53_2048x2048.jpg?v=1698420196\"]").attr("alt", "Yoga accessories including blocks, strap, spray, and mat");

//yoga supplies

  $("img[src=\"//jadeyoga.com/cdn/shop/files/Untitled_15_2048x2048.jpg?v=1697832644\"]").attr("alt", "Yoga products including blocks, strap, spray bottle, and mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/6843_2048x2048.jpg?v=1511304540\"]").attr("alt", "Teal yoga mat with black underside and JadeYoga branding");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/6825_b409bde4-c5b5-4caf-a941-85b688b9653b_2048x2048.jpg?v=1511304541\"]").attr("alt", "Black yoga strap with silver D-rings, coiled and unfolded");
    $("img[src=\"//jadeyoga.com/cdn/shop/products/6845_2048x2048.jpg?v=1581158356\"]").attr("alt", "Cork yoga block with Jade Yoga logo");

//jade yoga gift card

  $("img[src=\"//jadeyoga.com/cdn/shop/products/Jade-Yoga-Gift-Card_2048x2048.jpg?v=1632440460\"]").attr("alt", "Jade Yoga gift card");
//second mat 

 $("img[src=\"//jadeyoga.com/cdn/shop/files/7611B297-30F8-49E1-B032-02D63698670F_2048x2048.jpg?v=1739394044\"]").attr("alt", "Rolled up black yoga mat");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/CA826EEF-3782-4302-A1DC-36D83662C54C_2048x2048.jpg?v=1739394044\"]").attr("alt", "Rolled up black yoga mat on wooden floor");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/587216AF-1DE4-4CFE-AB41-9A1F4F3EBE93_2048x2048.jpg?v=1739394044\"]").attr("alt", "Rolled up yoga mat on wooden floor");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/5F6BE452-DFD7-4DEA-BD82-A73A845C945C_2048x2048.jpg?v=1739394044\"]").attr("alt", "Cork yoga mat on wooden surface");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/B745F042-A1F9-4E4D-901D-8B3CC1916538_2048x2048.jpg?v=1739394044\"]").attr("alt", "Rolled yoga mat with green top and cork bottom");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/2A53B94B-75FD-4958-AECC-1279BD08F683_2048x2048.jpg?v=1739394044\"]").attr("alt", "Jade Yoga mat bag");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/00D944DF-0ECA-475C-B2E5-588559D898FC_2048x2048.jpg?v=1740156431\"]").attr("alt", "Rolled up blue yoga mat with brand label visible");
    $("img[src=\"//jadeyoga.com/cdn/shop/files/137C4DE6-CA0C-4550-9A1E-F67841C5E300_2048x2048.jpg?v=1740156431\"]").attr("alt", "Rolled up blue yoga mat on wooden floor");

},1000)


 
console.log("ready1");

$('.flickity-page-dots').attr('role','tablist');
$('.flickity-page-dots .dot').attr('role','tab');
$(document).on('keydown', '.flickity-page-dots .dot', function(e){
  if(e.key === 'Enter' || e.key === ' '){
    e.preventDefault();
    $(this).click();
  }
});



$('a.slide__btn[href="https://jadeyoga.com/collections/yoga-mats/products/jade-harmony-2-0"]')
  .attr('aria-label','Shop now for New Harmony 2.0 yoga mat');

  $('a.slide__btn[href="/products/jade-mushroom-mat"]')
  .attr('aria-label','Shop now for Jade Mushroom yoga mat');

// 🧘 Product pages (absolute + relative)

$('a.slide__btn[href="https://jadeyoga.com/products/jade-extra-yoga-mat"], a.slide__btn[href="/products/jade-extra-yoga-mat"]')
  .attr('aria-label','Shop now for Jade Extra yoga mat');

$('a.slide__btn[href="https://jadeyoga.com/products/jade-cork-yoga-mat"], a.slide__btn[href="/products/jade-cork-yoga-mat"]')
  .attr('aria-label','Shop now for Jade Cork yoga mat');

$('a.slide__btn[href="https://jadeyoga.com/products/double-grip-chamois-yoga-towel"], a.slide__btn[href="/products/double-grip-chamois-yoga-towel"]')
  .attr('aria-label','Shop now for Double Grip Chamois yoga towel');


// 🎁 Collections

$('a.slide__btn[href="https://jadeyoga.com/collections/gift-packages"], a.slide__btn[href="/collections/gift-packages"]')
  .attr('aria-label','View yoga gift packages');

$('a.slide__btn[href="https://jadeyoga.com/collections/yoga-mats"], a.slide__btn[href="/collections/yoga-mats"]')
  .attr('aria-label','Shop no-slip grip yoga mats');


// 🧠 Quiz

$('a.slide__btn[href="#quiz-EgHk3g"]')
  .attr('aria-label','Take the quiz to find your perfect yoga mat');


// 🌱 Causes (improved label)

$('a.slide__btn[href="https://jadeyoga.com/pages/causes"]')
  .attr('aria-label','Learn about our cause and how your purchase helps plant a tree');
$('a.btn.btn--secondary.call-to-action[href="/pages/causes"]')
  .attr('aria-label','Learn about our cause and how your purchase helps plant a tree');
  


// 🎥 Video

$('a.slide__btn.video-text-link[href="https://youtu.be/t4wyTJ8rJTs"]')
  .attr('aria-label','Watch video: Safe for the whole family');

  $('#ContactForm .form__item--submit button[type="submit"]')
  .attr('aria-label','Send contact form message');
});




